<script lang="ts">
  import * as Command from "$lib/components/ui/command/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { createEventDispatcher, tick } from "svelte";
  import CaretSort from "svelte-radix/CaretSort.svelte";
  import Check from "svelte-radix/Check.svelte";
  import { cn } from "$lib/utils";
  import { type CustomerType } from "$src/domain/customers/CustomerType";
  import { useCustomerTypes } from "../hooks/useCustomerTypes";
  import { getTranslation } from "$src/presentation/core/TranslatedTextUtils";
  import { languageCode } from "$src/presentation/core/languageCode";
  import { t } from "svelte-i18n";

  export let groupStoreId: number;

  let customerTypesQuery = useCustomerTypes(groupStoreId);

  let open = false;

  let className: string | undefined = undefined;
  export { className as class };
  export let value: CustomerType | undefined;

  const dispatch = createEventDispatcher();

  function selectType(customerType: CustomerType | undefined) {
    dispatch('selectType', customerType);
  }

  // We want to refocus the trigger button when the user selects
  // an item from the list so users can continue navigating the
  // rest of the form with the keyboard.
  function closeAndFocusTrigger(triggerId: string) {
    open = false;
    // tick().then(() => {
    //   document.getElementById(triggerId)?.focus();
    // });
  }
</script>

<Popover.Root bind:open let:ids>
  <Popover.Trigger asChild let:builder>
    <Button
      builders={[builder]}
      variant="outline"
      role="combobox"
      aria-expanded={open}
      class={cn("w-[275px] justify-between text-xs", className)}
    >
      <div class="flex-grow">
        {#if value}
          {getTranslation(value?.translations, $languageCode)}
        {:else}
          {$t("page.customers.labels.select-type")}
        {/if}
      </div>
      <div>
        <CaretSort class="flex-shrink-0 ml-2 h-4 w-4 opacity-50" />
      </div>
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-[200px] p-0">
    <Command.Root>
      <Command.Group>
        {#if $customerTypesQuery.isSuccess}
          {#each $customerTypesQuery.data as customerType}
            <Command.Item
              value={customerType.id.toString()}
              onSelect={(currentValue) => {
                value = $customerTypesQuery.data.find(
                  (s) => s.id.toString() == currentValue
                );
                closeAndFocusTrigger(ids.trigger);
                selectType(value);
              }}
            >
              <Check
                class={cn(
                  "mr-2 h-4 w-4",
                  value?.id !== customerType.id && "text-transparent"
                )}
              />
              {getTranslation(customerType.translations, $languageCode)}
            </Command.Item>
          {/each}
        {/if}
      </Command.Group>
    </Command.Root>
  </Popover.Content>
</Popover.Root>
